module.exports = __webpack_public_path__ + "static/media/kidbrooke.c1ef85ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kidbrooke.jpg
// module id = 295
// module chunks = 0